import { JobRejectionReasonDTO } from '../../interfaces/job-rejection/job-rejection-reason.dto.interface';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IIncidentClosureReasonDTO } from '../../interfaces/incident';

@Injectable({ providedIn: 'root' })
export class JobRejectionReasonService {
  baseUrl = '/api/job-rejection-reasons';

  constructor(public http: HttpClient) {}

  public getJobRejectionReasons(includeInactive = false): Promise<JobRejectionReasonDTO[]> {
    return this.http
      .get<JobRejectionReasonDTO[]>(`${this.baseUrl}?all=${includeInactive}`)
      .toPromise();
  }

  addRejectionReason(reason: IIncidentClosureReasonDTO): Promise<any> {
    return this.http.post(`${this.baseUrl}/add`, reason).toPromise();
  }

  activateRejectionReason(id: number) {
    return this.http.put(`${this.baseUrl}/${id}/activate`, {}).toPromise();
  }

  deactivateRejectionReason(id: number) {
    return this.http.put(`${this.baseUrl}/${id}/deactivate`, {}).toPromise();
  }
}
